import { Component, input, output } from '@angular/core';
import { ServiceTileType } from '../../cisco/user-detail-home/service-tile-type.model';

@Component({
  selector: 'ziro-service-tile',
  templateUrl: './service-tile.component.html',
  standalone: false,
})
export class ZiroServiceTileComponent {
  serviceTileType = ServiceTileType;

  readonly tileType = input<ServiceTileType>();

  // Common Inputs for tiles
  readonly serviceName = input<string>();
  readonly serviceType = input<string>();
  readonly serviceState = input<string>();
  readonly icon = input<string>();
  readonly isEnabled = input(true);
  readonly isDisplayed = input(true);
  readonly tooltip = input<string>();
  readonly description = input<string>();
  readonly dataAutomation = input<string>();

  // Add Tile Inputs + Outputs
  readonly isAdding = input(false);
  readonly isInProgress = input<boolean>();
  readonly isInProgressBadgeText = input('tkey;userdetail.microsoft_365.licensing_in_progress.badge.text');
  readonly addTileClicked = output();

  // Delete Tile-specific Inputs + Outputs
  readonly isDeleting = input(false);
  readonly isDeleted = input(false);
  readonly deleteTileConfirmButtonClicked = output();
  readonly deleteTileCancelButtonClicked = output();

  // Edit Tile-specific Inputs
  readonly isDeskPhone = input(false);
  readonly isDevice = input(false);
  readonly isStatusCheckInProgress = input(false);
  readonly hasMultipleDeskPhones = input(false);
  readonly deleteTooltip = input<string>();
  readonly deviceToolip = input<string>();
  readonly immediateCallForwardingTooltip = input<string>('');
  readonly deviceIconMarkup = input<string>();
  readonly isDeleteEnabled = input(true);
  readonly isDeleteShown = input(true);
  readonly isExchangeEnabled = input(true);
  readonly isExchangeShown = input(false);
  readonly phone = input<{
    serverId: number;
    name: string;
  }>();
  readonly isBeta = input(false);
  readonly editTileClicked = output();
  readonly editTileDeleteClicked = output();
  readonly editTileExchangeClicked = output();
  readonly editDeskPhoneClicked = output();
  readonly editDeskPhoneAddClicked = output();
  readonly editDeskPhoneCopyClicked = output();
  readonly isImmediateCallForwardingEnabled = input<boolean>(false);

  // Warning overlay
  readonly showWarning = input(false);
  readonly warningTooltip = input<string>('');

  // Multi Edit Tiles Inputs
  readonly multiEditTiles = input<
    {
      serviceName: string;
      description: string;
      icon: string;
    }[]
  >();
  readonly multiEditAddClicked = output();

  onAddTileClicked(): void {
    this.addTileClicked.emit();
  }

  onDeleteTileConfirmButtonClicked(): void {
    this.deleteTileConfirmButtonClicked.emit();
  }

  onDeleteTileCancelButtonClicked(): void {
    this.deleteTileCancelButtonClicked.emit();
  }

  onEditTileClicked(): void {
    this.editTileClicked.emit();
  }

  onEditTileDeleteClicked(): void {
    this.editTileDeleteClicked.emit();
  }

  onEditTileExchangeClicked(): void {
    this.editTileExchangeClicked.emit();
  }

  onEditDeskPhoneClicked(): void {
    this.editDeskPhoneClicked.emit();
  }

  onEditTileDeskPhoneAddClicked(): void {
    this.editDeskPhoneAddClicked.emit();
  }

  onEditTileDeskPhoneCopyClicked(): void {
    this.editDeskPhoneCopyClicked.emit();
  }

  onMultiEditAddClicked(): void {
    this.multiEditAddClicked.emit();
  }
}
